import { isCorpusCheckCode } from '../../types/quality';
/**
 * Where the texts of a check live (CZNA-1407). The ids contain `help`, so NK can reword
 * them in Settings → Texty nápovědy like any other help (CZNA-407, `isHelpMessageId`).
 */
var HELP_PREFIX = 'ui-czna-authorities.corpusQuality.checks.help';
export var corpusCheckTextId = function (code, part) { return ("".concat(HELP_PREFIX, ".").concat(code, ".").concat(part)); };
/**
 * Group and population unit per code — a property of the code, not of the run: the backend
 * says only how many it examined. `fix` is false for the NK questions Q1–Q5, which have no
 * agreed fix to describe; whether a row IS a question is still the row's status.
 */
var PROFILES = {
    K01: { group: 'oneSided', unit: 'links', fix: true },
    K02: { group: 'oneSided', unit: 'links', fix: true },
    K03: { group: 'oneSided', unit: 'links', fix: true },
    K04: { group: 'oneSided', unit: 'links', fix: true },
    K05: { group: 'oneSided', unit: 'links', fix: true },
    K06: { group: 'contradicting', unit: 'pairs', fix: true },
    K07: { group: 'contradicting', unit: 'pairs', fix: true },
    K08: { group: 'target', unit: 'references', fix: true },
    K09: { group: 'target', unit: 'references', fix: true },
    MONTHLY_DANGLING_SEE_ALSO: { group: 'target', unit: 'references', fix: true },
    MONTHLY_DUP_HEADING: { group: 'duplicate', unit: 'records', fix: true },
    Q1: { group: 'oneSided', unit: 'links', fix: false },
    Q2: { group: 'oneSided', unit: 'links', fix: false },
    Q3: { group: 'oneSided', unit: 'links', fix: false },
    Q4: { group: 'other', unit: 'pairs', fix: false },
    Q5: { group: 'contradicting', unit: 'links', fix: false },
    Q6_374A: { group: 'unlinkedValue', unit: 'occurrences', fix: true },
    Q6_372A: { group: 'unlinkedValue', unit: 'occurrences', fix: true },
    Q6_370C: { group: 'unlinkedValue', unit: 'occurrences', fix: true },
    Q6_368A: { group: 'unlinkedValue', unit: 'occurrences', fix: true },
    Q6_368C: { group: 'unlinkedValue', unit: 'occurrences', fix: true },
    S1: { group: 'wrongSubfield', unit: 'occurrences', fix: true },
};
export var corpusCheckGroup = function (code) { return (isCorpusCheckCode(code) ? PROFILES[code].group : 'other'); };
export var corpusCheckUnit = function (code) { return (isCorpusCheckCode(code) ? PROFILES[code].unit : 'none'); };
/** Display name of a corpus check (CZNA-1217); an unknown code shows as itself. */
export var corpusCheckLabel = function (intl, code) { return (isCorpusCheckCode(code)
    ? intl.formatMessage({ id: corpusCheckTextId(code, 'name') })
    : code); };
/** One sentence on what a finding of the check means; empty for an unknown code. */
export var corpusCheckMeaning = function (intl, code) { return (isCorpusCheckCode(code)
    ? intl.formatMessage({ id: corpusCheckTextId(code, 'meaning') })
    : ''); };
/** How to fix a finding; empty for an unknown code and for an NK question. */
export var corpusCheckFix = function (intl, code) { return (isCorpusCheckCode(code) && PROFILES[code].fix
    ? intl.formatMessage({ id: corpusCheckTextId(code, 'fix') })
    : ''); };
/** Every text id the checks need, for the translation and help-catalog tests. */
export var corpusCheckTextIds = function (code) { return (PROFILES[code].fix
    ? [corpusCheckTextId(code, 'name'), corpusCheckTextId(code, 'meaning'), corpusCheckTextId(code, 'fix')]
    : [corpusCheckTextId(code, 'name'), corpusCheckTextId(code, 'meaning')]); };
